import * as React from 'react'
import { observer } from 'mobx-react'
import { filterBarStore } from '../../collections'
import './product-searchable.scss'

interface IProps {
  content: string
  className?: string
}

@observer
export class ProductSearchable extends React.Component<IProps> {
  render(): React.ReactNode {
    let content: string = this.props.content
    const searchTerm: string = filterBarStore.searchTerm

    if (searchTerm) {
      const match: RegExp = new RegExp(searchTerm, 'gi')
      content = this.props.content.replace(match, '<span>$&</span>')
    }

    return (
      <p
        className={`product-searchable ${this.props.className || ''}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }
}
